/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {ArticleCard} from "@canopy-iiif/app/ui";
function _createMdxContent(props) {
  return <ArticleCard href={props.record?.href} title={props.record?.title || props.record?.href || "Untitled"} annotation={props.record?.annotation} summary={props.record?.summary || props.record?.summaryValue || ""} summaryMarkdown={props.record?.summaryMarkdown || props.record?.summary || props.record?.summaryValue || ""} metadata={Array.isArray(props.record?.metadata) ? props.record.metadata : []} query={props.query} recordType={props.record?.type} />;
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}
